const { ccclass } = cc._decorator;
import ModuleBase, { ViewLayer, bindButtonClickEvent, moduleInit } from "../../../framework/core/mvvm/module_base";
import ModuleManager from "../../../framework/core/module_manager";
import DialogTips from "../../public/module/dialog_tips/dialog_tips";
import ModelData from "../../public/model_data";
import ClubRecordView from "./club_record_view";

@ccclass
@moduleInit("ClubRecord")
export default class ClubRecord extends ModuleBase<ClubRecordView, null>  {
    clubId = null
    gerenData = null
    shouruData = null
    constructor() {
        super()
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = 'package/club/module/club_record';       
        this.viewType = ClubRecordView;
        this.needDeferShow = true
        this.needAnim = true
        this.autoShowAnim = true
        this.needViewMask = true
    }

    protected onDeferShow(intentData) {
        this.clubId = intentData
        this.onButtonClickName("GeRenBtn")
        this.getQueryLogData()
    }

    onInit(){
        this.bindEvent();
    }


    protected onButtonClickName(name : string) {
        switch (name) {
            case "BackBtn":
                ModuleManager.instance.hideModule("ClubRecord")
                break;
            case "GeRenBtn":
                this.view.changeBtn(true)
                break
            case "ShouRuBtn":
                this.view.changeBtn(false)
                break  
            default:
                break;
        }
    }


    //个人记录
    getQueryLogData(){
        let self = this
        let requestData: IHttpRequestData = {
            baseUrl: "club/oplog/queryLog?",
            params: {
                userClubId:self.clubId,
                pageNum:1,
                gameUserId: ModelData.instance.roleData.id,
            },
            showNetPrompt:true
        }
        this.apiHttpGet(requestData, (respone) => {
            self.show()
            self.gerenData = respone.data
            self.view.updateShow(self.gerenData.list)
            //self.view.showBaseInfo(respone.data, ModelData.instance.roleData)//更新数据
        })
    }

    //个人记录
    getQueryBalanceINlogData(){
        let self = this
        let requestData: IHttpRequestData = {
            baseUrl: "club/oplog/queryBalanceINlog?",
            params: {
                userClubId:self.clubId,
                pageNum:1,
                gameUserId: ModelData.instance.roleData.id,
            },
            showNetPrompt:true
        }
        this.apiHttpGet(requestData, (respone) => {
            self.shouruData = respone.data
        })
    }


    bindEvent(){

    }
}